<div class="card">
    <div class="font-semibold text-xl mb-4">Sucursales HOY</div>
    <p-chart type="line" [data]="lineData" [options]="lineOptions"></p-chart>
</div>